<div class="demo chip-container">
  <div class="shadowbox">
    <div class="main" (click)="exitDemoMode()">
      <span class="demo">DEMO</span>
      <span class="exit">EXIT</span>
    </div>
    <div class="slanted-container">
      <div class="slanted-1"></div>
      <div class="slanted-2"></div>
      <div class="slanted-3"></div>
    </div>
  </div>
</div>
